import { Component, OnDestroy, OnInit } from '@angular/core';
import '@tm1/design-system';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/AuthService';
import { VenueService } from '../../../services/VenueService';
import { VenueEntry } from '../../../models/venue-admin.model';
import { Apiservice } from '../../../services/ApiService';
import { StorageService } from '../../../services/StorageService';
import * as XLSX from 'xlsx';
import { environment } from '../../../environments/environments';
import { DateTime } from 'luxon';
import * as pako from 'pako';
import { PermissionsService } from '../../../services/Permissions';
import { ChartData, ChartOptions } from 'chart.js';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-attendance',
  standalone: false,
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss', '../styles/shared.scss'],
})
export class AttendanceComponent implements OnInit, OnDestroy {
  private socket: WebSocket | null = null;
  /** Guards against overlapping connects so a reconnect can't stack a second socket. */
  private connecting: boolean = false;
  isLoggedin;
  admin;
  ticketmaster;
  deliveryAdmin;
  venueAdmin;
  venuelist: VenueEntry[] = [];
  /** Keys of venues that have scanned within the active-scan window. */
  activeVenueKeys: Set<string> = new Set<string>();
  /** How often to refresh the "scanning now" set, in milliseconds. */
  private readonly ACTIVE_SCAN_POLL_MS = 5 * 60 * 1000;
  /** Handle for the active-scan poll, so it can be cleared on destroy. */
  private activeScanPollId: ReturnType<typeof setInterval> | null = null;
  Selectedvenue: string = '';
  SelectedSession: string = '';
  selectedSessionLabel: string = 'Full Day Report';
  venueValue: any = '';
  date: string = '';
  currentDate = Date();
  endDate: string = '';
  dateRange: boolean = false;
  loading: boolean = false;
  attendanceSummary: any = {};
  groupedInside: any = {};
  displayData: boolean = false;
  entranceGroupTable: string = '';
  showSummary: boolean = false;
  showGroup: boolean = false;
  showEntrance: boolean = true;
  showEvent: boolean = false;
  showTicket: boolean = false;
  showGraph: boolean = false;
  showTimedEntries: boolean = false;
  isModalOpen: boolean = false;
  isSessionModalOpen: boolean = false;
  isScheduleModalOpen: boolean = false;
  isManageSessionsModalOpen: boolean = false;
  manageSessionsDate: string = '';
  manageSessionsList: Array<{ key: string; startTime: string; endTime: string; name: string }> = [];
  manageSessionsNewName: string = '';
  manageSessionsNewStart: string = '';
  manageSessionsNewEnd: string = '';
  manageSessionsLoading: boolean = false;
  manageSessionsSaving: boolean = false;
  manageSessionsError: string = '';
  manageSessionsSuccess: string = '';
  readonly manageSessionsTimePresets: string[] = Array.from({ length: 96 }, (_, i) => {
    const hours = Math.floor(i / 4);
    const minutes = (i % 4) * 15;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  });
  scheduleLoading: boolean = false;
  scheduleError: string = '';
  scheduleSuccess: string = '';
  allSchedules: any[] = [];
  scheduleName: string = '';
  scheduleSendType: 'interval' | 'fixed' = 'interval';
  scheduleFrequency: number = 5;
  scheduleStartTime: string = '';
  scheduleEndTime: string = '';
  scheduleSendTime: string = '';
  scheduleEmails: string[] = [];
  scheduleEmailInput: string = '';
  scheduleFrequencyOptions: number[] = [5, 10, 15, 30, 60];
  currentUserID: string = '';
  scheduleDate: string = '';
  copyToDate: string = '';
  showCopyDatePicker: boolean = false;
  scheduleEditMode: boolean = false;
  selectedScheduleId: number | null = null;
  editingExistingSchedule: boolean = false;
  shareLink: string = '';
  shareKey: any;
  manualSocketClose: boolean = false;
  stopDataToggle: boolean = false;
  LiveDate: string = '';
  liveButton: boolean = false;
  ninetyDaysAgo = new Date(new Date().getTime() - 90 * 24 * 3600 * 1000)
    .toISOString()
    .replace(/ GMT$/, '')
    .split('T')[0];
  astatreport: string = '';
  latency: string = '';
  timedGateEntries: any[] = [];
  timedScannerEntries: any[] = [];
  selectedGates: string[] = [];
  selectedScanners: string[] = [];
  gateChartData: ChartData = {
    labels: [],
    datasets: [],
  };
  scannerChartData: ChartData = {
    labels: [],
    datasets: [],
  };
  chartOptions: ChartOptions = this.buildChartOptions(false);

  private buildChartOptions(isDark: boolean): ChartOptions {
    const textColor = isDark ? '#e2e8f0' : '#1f2328';
    const mutedTextColor = isDark ? '#94a3b8' : '#475569';
    const gridColor = isDark ? 'rgba(148, 163, 184, 0.15)' : 'rgba(15, 23, 42, 0.08)';
    const tooltipBg = isDark ? 'rgba(15, 23, 42, 0.95)' : 'rgba(255, 255, 255, 0.95)';
    const tooltipText = isDark ? '#f8fafc' : '#0f172a';
    const tooltipBorder = isDark ? '#334155' : '#e6e8ec';

    return {
      responsive: true,
      maintainAspectRatio: false,
      // Live socket updates rebuild the datasets on every incoming record, which
      // makes ng2-charts call chart.update() and replay the transition animation
      // each time — visually a flicker/refresh. Disabling animation keeps the
      // chart static across updates so new points appear without re-animating.
      animation: false,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: textColor,
          },
        },
        tooltip: {
          backgroundColor: tooltipBg,
          titleColor: tooltipText,
          bodyColor: tooltipText,
          borderColor: tooltipBorder,
          borderWidth: 1,
          callbacks: {
            label: (context: { dataset: any; dataIndex: any }) => {
              const dataset = context.dataset as any;
              const index = context.dataIndex;

              const entries = dataset.data[index];
              const exits = dataset.customMetrics?.exits[index] ?? 0;
              const reentries = dataset.customMetrics?.reentries[index] ?? 0;

              return [
                `Entries: ${entries}`,
                `Exits: ${exits}`,
                `Reentries: ${reentries}`,
              ];
            },
          },
        },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: 'Time',
            color: mutedTextColor,
          },
          ticks: {
            color: mutedTextColor,
          },
          grid: {
            color: gridColor,
          },
        },
        y: {
          title: {
            display: true,
            text: 'Entries',
            color: mutedTextColor,
          },
          ticks: {
            color: mutedTextColor,
          },
          grid: {
            color: gridColor,
          },
        },
      },
    } as ChartOptions;
  }

  private refreshChartOptions(): void {
    const next: 'light' | 'dark' =
      this.useModernView && this.useDarkMode ? 'dark' : 'light';
    if (next === this.lastChartTheme) return;
    this.lastChartTheme = next;
    this.chartOptions = this.buildChartOptions(next === 'dark');
    if (this.timedGateEntries.length || this.timedScannerEntries.length) {
      this.updateChart();
    }
  }
  processedTicketTypes: any[] = [];
  useModernView: boolean = true;
  useDarkMode: boolean = false;
  /** Whether the full-screen big-screen dashboard overlay is open. */
  bigScreenOpen: boolean = false;
  activeGraphTab: 'gate' | 'scanner' = 'gate';
  private modernViewHandler = (event: Event) => {
    const detail = (event as CustomEvent<boolean>).detail;
    this.useModernView = !!detail;
    this.applyDarkModeToBody();
    this.refreshChartOptions();
  };
  rejectColumnsByTable: {
    entrances: string[];
    events: string[];
    groupedEntries: string[];
    childVenues: string[];
    ticketTypes: string[];
  } = { entrances: [], events: [], groupedEntries: [], childVenues: [], ticketTypes: [] };
  sortedEntranceKeysCache: string[] = [];
  sortedEventKeysCache: string[] = [];
  sortedGroupedKeysCache: string[] = [];
  sortedChildVenueKeysCache: string[] = [];
  sortedTicketTypesCache: any[] = [];
  rejectsExpanded: {
    entrances: boolean;
    events: boolean;
    groupedEntries: boolean;
    childVenues: boolean;
    ticketTypes: boolean;
  } = { entrances: false, events: false, groupedEntries: false, childVenues: false, ticketTypes: false };
  sortState: {
    entrances: { key: string; dir: 'asc' | 'desc' };
    events: { key: string; dir: 'asc' | 'desc' };
    groupedEntries: { key: string; dir: 'asc' | 'desc' };
    childVenues: { key: string; dir: 'asc' | 'desc' };
    ticketTypes: { key: string; dir: 'asc' | 'desc' };
  } = {
    entrances: { key: 'name', dir: 'asc' },
    events: { key: 'name', dir: 'asc' },
    groupedEntries: { key: 'name', dir: 'asc' },
    childVenues: { key: 'name', dir: 'asc' },
    ticketTypes: { key: 'database', dir: 'asc' },
  };
  venueTimezone: string = '';
  sessions: any[] = [];
  session: boolean = false;
  selectedSessionTime: any = {};
  sessionStart: string = '';
  sessionEnd: string = '';
  dropdownOpen = false;
  scannerDropdownOpen = false;
  fifteenMinIndices: number[] = [];
  filteredScannerEntries: any[] = [];
  filteredGateEntries: any[] = [];
  chartColors: string[] = [
    '#1f77b4',
    '#ff7f0e',
    '#2ca02c',
    '#d62728',
    '#9467bd',
    '#8c564b',
    '#e377c2',
    '#7f7f7f',
    '#bcbd22',
    '#17becf',
    '#393b79',
    '#637939',
    '#8c6d31',
    '#843c39',
    '#7b4173',
    '#5254a3',
    '#6b6ecf',
    '#9c9ede',
    '#637939',
    '#8ca252',
    '#bd9e39',
    '#e7ba52',
    '#ad494a',
    '#d6616b',
    '#7b4173',
    '#a55194',
    '#ce6dbd',
    '#de9ed6',
    '#3182bd',
    '#6baed6',
    '#9ecae1',
    '#c6dbef',
    '#e6550d',
    '#fd8d3c',
    '#fdae6b',
    '#fdd0a2',
    '#31a354',
    '#74c476',
    '#a1d99b',
    '#c7e9c0',
    '#756bb1',
    '#9e9ac8',
    '#bcbddc',
    '#dadaeb',
    '#636363',
    '#969696',
    '#bdbdbd',
    '#d9d9d9',
    '#393b79',
    '#5254a3',
    '#6b6ecf',
    '#9c9ede',
    '#637939',
    '#8ca252',
    '#b5cf6b',
    '#cedb9c',
    '#8c6d31',
    '#bd9e39',
    '#e7ba52',
  ];

  constructor(
    private permissions: PermissionsService,
    private storage: StorageService,
    private router: Router,
    private auth: AuthService,
    public venue: VenueService,
    private apiservice: Apiservice
  ) {
    this.isLoggedin = this.auth.isLoggedIn;
    this.admin = this.permissions.admin;
    this.ticketmaster = this.permissions.ticketmaster;
    this.deliveryAdmin = this.permissions.deliveryAdmin;
    this.venueAdmin = this.permissions.venueAdmin;
  }

  getVenueList() {
    this.venue.getVenueList().subscribe((data: VenueEntry[]) => {
      this.venuelist = data;
      this.loadActiveScans();
      this.startActiveScanPolling();

      // With access to a single venue there is nothing to pick, so select it
      // automatically and let the selector render it as a static label.
      const savedVenue =
        this.storage.getVenue() ||
        (this.venuelist.length === 1 ? this.venuelist[0].key : '');
      if (savedVenue) {
        this.Selectedvenue = savedVenue;

        const savedVenueObj = this.venuelist.find(
          (venue) => venue.key === this.Selectedvenue
        );

        this.venueValue = savedVenueObj ? savedVenueObj.value : null;
        this.venueTimezone = (this.venueValue as any)?.timezone;

        this.getCurrentDate();
        this.getVenueAttendance();
        this.getSessions();
      }
    });
  }

  onVenueChange() {
    this.storage.saveVenue(this.Selectedvenue);
    const selectedVenueObj = this.venuelist.find(
      (venue) => venue.key === this.Selectedvenue
    );
    this.venueValue = selectedVenueObj ? selectedVenueObj.value : null;
    this.selectedSessionTime = null;
    this.SelectedSession = '';
    this.venueTimezone = (this.venueValue as any)?.timezone;
    this.getCurrentDate();
    this.getVenueAttendance();
    this.getSessions();
    this.closeSocket();
    this.stopDataToggle = false;
  }

  /**
   * Fetches the set of venues currently "scanning now" for the venue selector's
   * pinned group. Failures are non-fatal: the selector simply omits the group.
   */
  private loadActiveScans() {
    this.venue.getActiveScanVenueIds().subscribe({
      next: (keys) => {
        this.activeVenueKeys = keys;
      },
      error: (err) => {
        console.error('Failed to load active scans', err);
        this.activeVenueKeys = new Set<string>();
      },
    });
  }

  /**
   * Starts polling the active-scan set every ACTIVE_SCAN_POLL_MS so the
   * "scanning now" group stays current while the page is open. Idempotent:
   * an existing poll is cleared first to avoid stacking intervals.
   */
  private startActiveScanPolling() {
    this.stopActiveScanPolling();
    this.activeScanPollId = setInterval(() => this.loadActiveScans(), this.ACTIVE_SCAN_POLL_MS);
  }

  private stopActiveScanPolling() {
    if (this.activeScanPollId !== null) {
      clearInterval(this.activeScanPollId);
      this.activeScanPollId = null;
    }
  }

  onDateChange() {
    this.storage.saveDate(this.date);
    if (this.Selectedvenue !== '') {
      this.closeSocket();
      this.getVenueAttendance();
      this.getSessions();
      this.selectedSessionTime = null;
      this.stopDataToggle = false;
    }
    this.closeSocket();
    this.stopDataToggle = false;
  }

  onEndDateChange() {
    if (this.date !== '') {
      this.getVenueAttendance();
    }
  }

  parseTimedGateEntries(timedGateEntries: any): any[] {
    const gatesData: any[] = [];
    const timestampsSet = new Set<number>();

    if (timedGateEntries !== undefined) {
      Object.keys(timedGateEntries).forEach((gate) => {
        const gateData = {
          gate,
          entries: [] as number[],
          exits: [] as number[],
          reentries: [] as number[],
          internal: [] as number[],
          inVenue: [] as number[],
          timestamps: [] as number[],
          formattedTimestamps: [] as string[],
        };

        Object.keys(timedGateEntries[gate]).forEach((utcTimestamp) => {
          const data = timedGateEntries[gate][utcTimestamp];

          const timestampNum = !isNaN(Number(utcTimestamp))
            ? Number(utcTimestamp)
            : new Date(utcTimestamp).getTime();

          if (!isNaN(timestampNum)) {
            timestampsSet.add(timestampNum);
            gateData.timestamps.push(timestampNum);
            gateData.formattedTimestamps.push(
              this.formatDate(new Date(timestampNum))
            );
            gateData.entries.push(Number(data?.entries || 0));
            gateData.exits.push(Number(data?.exits || 0));
            gateData.reentries.push(Number(data?.reentries || 0));
            gateData.internal.push(Number(data?.internal || 0));
            gateData.inVenue.push(Number(data?.inVenue || 0));
          } else {
            console.error('Invalid date:', utcTimestamp);
          }
        });

        gatesData.push(gateData);
      });

      const sortedTimestamps = Array.from(timestampsSet).sort((a, b) => a - b);
      const formattedTimestamps = sortedTimestamps.map((ts) =>
        this.formatDate(new Date(ts))
      );

      gatesData.forEach((gateData) => {
        const dataMap: { [key: number]: any } = {};
        gateData.timestamps.forEach((ts: number, idx: number) => {
          dataMap[ts] = {
            entries: gateData.entries[idx],
            exits: gateData.exits[idx],
            reentries: gateData.reentries[idx],
            internal: gateData.internal[idx],
            inVenue: gateData.inVenue[idx],
          };
        });

        gateData.timestamps = [];
        gateData.formattedTimestamps = [];
        gateData.entries = [];
        gateData.exits = [];
        gateData.reentries = [];
        gateData.internal = [];
        gateData.inVenue = [];

        sortedTimestamps.forEach((ts) => {
          gateData.timestamps.push(ts);
          const data = dataMap[ts] || {
            entries: 0,
            exits: 0,
            reentries: 0,
            internal: 0,
            inVenue: 0,
          };
          gateData.entries.push(data.entries);
          gateData.exits.push(data.exits);
          gateData.reentries.push(data.reentries);
          gateData.internal.push(data.internal);
          gateData.inVenue.push(data.inVenue);
        });

        gateData.formattedTimestamps = formattedTimestamps;
      });

      return gatesData;
    }

    return [];
  }

  parseTimedScannerEntries(timedScannerEntries: any): any[] {
    const scannerData: any[] = [];
    const timestampsSet = new Set<number>();

    if (timedScannerEntries !== undefined) {
      Object.keys(timedScannerEntries).forEach((gate) => {
        const gateData = {
          gate,
          entries: [] as number[],
          exits: [] as number[],
          reentries: [] as number[],
          internal: [] as number[],
          inVenue: [] as number[],
          timestamps: [] as number[],
          formattedTimestamps: [] as string[],
        };

        Object.keys(timedScannerEntries[gate]).forEach((utcTimestamp) => {
          const data = timedScannerEntries[gate][utcTimestamp];

          const timestampNum = !isNaN(Number(utcTimestamp))
            ? Number(utcTimestamp)
            : new Date(utcTimestamp).getTime();

          if (!isNaN(timestampNum)) {
            timestampsSet.add(timestampNum);
            gateData.timestamps.push(timestampNum);
            gateData.formattedTimestamps.push(
              this.formatDate(new Date(timestampNum))
            );
            gateData.entries.push(Number(data?.entries || 0));
            gateData.exits.push(Number(data?.exits || 0));
            gateData.reentries.push(Number(data?.reentries || 0));
            gateData.internal.push(Number(data?.internal || 0));
            gateData.inVenue.push(Number(data?.inVenue || 0));
          } else {
            console.error('Invalid date:', utcTimestamp);
          }
        });

        scannerData.push(gateData);
      });

      const sortedTimestamps = Array.from(timestampsSet).sort((a, b) => a - b);
      const formattedTimestamps = sortedTimestamps.map((ts) =>
        this.formatDate(new Date(ts))
      );

      scannerData.forEach((scannerData) => {
        const dataMap: { [key: number]: any } = {};
        scannerData.timestamps.forEach((ts: number, idx: number) => {
          dataMap[ts] = {
            entries: scannerData.entries[idx],
            exits: scannerData.exits[idx],
            reentries: scannerData.reentries[idx],
            internal: scannerData.internal[idx],
            inVenue: scannerData.inVenue[idx],
          };
        });

        scannerData.timestamps = [];
        scannerData.formattedTimestamps = [];
        scannerData.entries = [];
        scannerData.exits = [];
        scannerData.reentries = [];
        scannerData.internal = [];
        scannerData.inVenue = [];

        sortedTimestamps.forEach((ts) => {
          scannerData.timestamps.push(ts);
          const data = dataMap[ts] || {
            entries: 0,
            exits: 0,
            reentries: 0,
            internal: 0,
            inVenue: 0,
          };
          scannerData.entries.push(data.entries);
          scannerData.exits.push(data.exits);
          scannerData.reentries.push(data.reentries);
          scannerData.internal.push(data.internal);
          scannerData.inVenue.push(data.inVenue);
        });

        scannerData.formattedTimestamps = formattedTimestamps;
      });

      return scannerData;
    }

    return [];
  }

  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: this.venueTimezone,
    };

    const formatted = date.toLocaleString('en-AU', options);
    return formatted;
  }

  formatErrorCode(code: string): string {
    if (!code) return '';
    return code
      .toLowerCase()
      .split(/[_\s]+/)
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }

  collectRejectCodes(items: any): string[] {
    const set = new Set<string>();
    const list = Array.isArray(items) ? items : Object.values(items || {});
    for (const item of list) {
      const rejects = (item as any)?.rejects;
      if (rejects) {
        for (const code of Object.keys(rejects)) {
          set.add(code);
        }
      }
    }
    return Array.from(set).sort();
  }

  rejectCount(rejects: { [code: string]: number } | undefined | null, code: string): number {
    if (!rejects) return 0;
    return Number(rejects[code] || 0);
  }

  rejectTotal(rejects: { [code: string]: number } | undefined | null): number {
    if (!rejects) return 0;
    let total = 0;
    for (const k of Object.keys(rejects)) {
      total += Number(rejects[k] || 0);
    }
    return total;
  }

  rejectPercent(row: any): number {
    if (!row) return 0;
    const rejects = this.rejectTotal(row.rejects);
    if (!rejects) return 0;
    const denom =
      Number(row.entries || 0) +
      Number(row.exits || 0) +
      Number(row.internal || 0) +
      Number(row.reentries || 0);
    if (!denom) return 0;
    return (rejects / denom) * 100;
  }

  toggleRejectsExpanded(table: keyof AttendanceComponent['rejectsExpanded']): void {
    this.rejectsExpanded[table] = !this.rejectsExpanded[table];
  }

  toggleSort(table: keyof AttendanceComponent['sortState'], key: string): void {
    const current = this.sortState[table];
    if (current.key === key) {
      current.dir = current.dir === 'asc' ? 'desc' : 'asc';
    } else {
      current.key = key;
      current.dir = key === 'name' || key === 'database' || key === 'event' || key === 'ticketType' ? 'asc' : 'desc';
    }
    this.refreshSortedCaches();
  }

  refreshSortedCaches(): void {
    this.sortedEntranceKeysCache = this.sortKeyedRows(this.attendanceSummary?.entrances, 'entrances').map((r) => r.key);
    this.sortedEventKeysCache = this.sortKeyedRows(this.attendanceSummary?.events, 'events').map((r) => r.key);
    this.sortedGroupedKeysCache = this.sortKeyedRows(this.attendanceSummary?.groupedEntries, 'groupedEntries').map((r) => r.key);
    this.sortedChildVenueKeysCache = this.sortKeyedRows(this.attendanceSummary?.childVenues, 'childVenues').map((r) => r.key);
    const list = [...this.processedTicketTypes];
    const { key, dir } = this.sortState.ticketTypes;
    list.sort((a, b) => {
      let av: any;
      let bv: any;
      if (key === '__rejectTotal') {
        av = this.rejectTotal(a?.rejects);
        bv = this.rejectTotal(b?.rejects);
      } else if (key === '__rejectPct') {
        av = this.rejectPercent(a);
        bv = this.rejectPercent(b);
      } else if (key.startsWith('__reject:')) {
        const code = key.slice('__reject:'.length);
        av = this.rejectCount(a?.rejects, code);
        bv = this.rejectCount(b?.rejects, code);
      } else {
        av = a?.[key];
        bv = b?.[key];
      }
      return this.compareValues(av, bv, dir);
    });
    this.sortedTicketTypesCache = list;
  }

  sortIndicator(table: keyof AttendanceComponent['sortState'], key: string): string {
    const s = this.sortState[table];
    if (s.key !== key) return '';
    return s.dir === 'asc' ? '▲' : '▼';
  }

  private compareValues(a: any, b: any, dir: 'asc' | 'desc'): number {
    const an = Number(a);
    const bn = Number(b);
    const aNum = !isNaN(an) && a !== null && a !== '';
    const bNum = !isNaN(bn) && b !== null && b !== '';
    let cmp: number;
    if (aNum && bNum) {
      cmp = an - bn;
    } else {
      cmp = String(a ?? '').localeCompare(String(b ?? ''));
    }
    return dir === 'asc' ? cmp : -cmp;
  }

  private sortKeyedRows(
    obj: { [key: string]: any } | undefined | null,
    table: keyof AttendanceComponent['sortState']
  ): { key: string; row: any }[] {
    if (!obj) return [];
    const rows = Object.keys(obj).map((key) => ({ key, row: obj[key] }));
    const { key: sortKey, dir } = this.sortState[table];
    rows.sort((a, b) => {
      let av: any;
      let bv: any;
      if (sortKey === 'name') {
        av = a.key;
        bv = b.key;
      } else if (sortKey === '__rejectTotal') {
        av = this.rejectTotal(a.row?.rejects);
        bv = this.rejectTotal(b.row?.rejects);
      } else if (sortKey === '__rejectPct') {
        av = this.rejectPercent(a.row);
        bv = this.rejectPercent(b.row);
      } else if (sortKey === 'inVenue' && table === 'groupedEntries') {
        av = this.groupedInside[a.key] ?? 0;
        bv = this.groupedInside[b.key] ?? 0;
      } else if (sortKey.startsWith('__reject:')) {
        const code = sortKey.slice('__reject:'.length);
        av = this.rejectCount(a.row?.rejects, code);
        bv = this.rejectCount(b.row?.rejects, code);
      } else {
        av = a.row?.[sortKey];
        bv = b.row?.[sortKey];
      }
      return this.compareValues(av, bv, dir);
    });
    return rows;
  }


  updateChart(): void {
    if (!this.timedGateEntries.length && !this.timedScannerEntries?.length)
      return;

    const gateTimestamps = this.timedGateEntries[0]?.timestamps || [];
    const scannerTimestamps = this.timedScannerEntries[0]?.timestamps || [];
    const gateTimestampsSorted = Array.from(new Set([...gateTimestamps])).sort(
      (a, b) => a - b
    );
    const scannerTimestampsSorted = Array.from(
      new Set([...scannerTimestamps])
    ).sort((a, b) => a - b);
    const gateFormattedTimestamps = gateTimestampsSorted.map((ts) =>
      this.formatDate(new Date(ts))
    );
    const scannerFormattedTimestamps = scannerTimestampsSorted.map((ts) =>
      this.formatDate(new Date(ts))
    );
    const gateDatasets: any[] = [];
    const scannerDatasets: any[] = [];

    this.selectedGates.forEach((gate) => {
      const gateData = this.timedGateEntries.find(
        (entry) => entry.gate === gate
      );
      if (gateData) {
        const data = gateTimestampsSorted.map((ts) => {
          const idx = gateData.timestamps.indexOf(ts);
          return idx !== -1 ? gateData.entries[idx] : 0;
        });
        gateDatasets.push({
          label: gate,
          data,
          borderColor:
            this.chartColors[gateDatasets.length % this.chartColors.length],
          fill: true,
          tension: 0.4,
          customMetrics: {
            exits: gateData?.exits || [],
            reentries: gateData?.reentries || [],
            internal: gateData?.internal || [],
            inVenue: gateData?.inVenue || [],
          },
        });
      }
    });

    this.selectedScanners.forEach((scanner) => {
      const scannerData = this.timedScannerEntries.find(
        (entry) => entry.gate === scanner
      );
      if (scannerData) {
        const data = scannerTimestampsSorted.map((ts) => {
          const idx = scannerData.timestamps.indexOf(ts);
          return idx !== -1 ? scannerData.entries[idx] : 0;
        });
        scannerDatasets.push({
          label: scanner,
          data,
          borderColor:
            this.chartColors[scannerDatasets.length % this.chartColors.length],
          fill: false,
          tension: 0.4,
        });
      }
    });

    if (this.timedGateEntries.length > 0) {
      const timeCount = gateTimestampsSorted.length;
      const totalEntries = Array.from({ length: timeCount }, (_, i) =>
        this.timedGateEntries.reduce((sum, gd) => sum + (gd.entries[i] ?? 0), 0)
      );
      const totalExits = Array.from({ length: timeCount }, (_, i) =>
        this.timedGateEntries.reduce((sum, gd) => sum + (gd.exits[i] ?? 0), 0)
      );
      const totalReentries = Array.from({ length: timeCount }, (_, i) =>
        this.timedGateEntries.reduce((sum, gd) => sum + (gd.reentries[i] ?? 0), 0)
      );
      gateDatasets.push({
        label: 'Total',
        data: totalEntries,
        borderColor: this.useModernView && this.useDarkMode ? '#f8fafc' : '#000000',
        fill: false,
        borderWidth: 2,
        tension: 0.4,
        customMetrics: {
          exits: totalExits,
          reentries: totalReentries,
        },
      });
    }

    if (this.timedScannerEntries.length > 0) {
      const timeCount = scannerTimestampsSorted.length;
      const totalEntries = Array.from({ length: timeCount }, (_, i) =>
        this.timedScannerEntries.reduce((sum, sd) => sum + (sd.entries[i] ?? 0), 0)
      );
      scannerDatasets.push({
        label: 'Total',
        data: totalEntries,
        borderColor: this.useModernView && this.useDarkMode ? '#f8fafc' : '#000000',
        fill: false,
        borderWidth: 2,
        tension: 0.4,
      });
    }

    this.gateChartData.labels = gateFormattedTimestamps;
    this.gateChartData.datasets = gateDatasets;
    this.scannerChartData.labels = scannerFormattedTimestamps;
    this.scannerChartData.datasets = scannerDatasets;
  }

  toggleGateSelection(gate: string): void {
    const index = this.selectedGates.indexOf(gate);
    if (index === -1) {
      this.selectedGates.push(gate);
    } else {
      this.selectedGates.splice(index, 1);
    }
    this.updateChart();
  }

  toggleScannerSelection(scanner: string): void {
    const index = this.selectedScanners.indexOf(scanner);
    if (index === -1) {
      this.selectedScanners.push(scanner);
    } else {
      this.selectedScanners.splice(index, 1);
    }
    this.updateChart();
  }

  getFifteenMinIndices(): number[] {
  if (!this.timedGateEntries.length) return [];

  return this.timedGateEntries[0].timestamps
    .map((ts: any, i: any) => ({ ts, i }))
    .filter((item: { ts: string | number | Date; }) => {
      const date = new Date(item.ts);
      return date.getMinutes() % 15 === 0;
    })
    .map((item: { i: any; }) => item.i);
}

  updateFifteenMinIndices(): void {
    this.fifteenMinIndices = this.getFifteenMinIndices();
  }

get allGatesSelected(): boolean {
  return this.selectedGates.length > 0;
}

  getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getVenueAttendance() {
    this.loading = true;
    this.session = false;
    this.closeSocket();
    const rawSession = this.SelectedSession?.split('_')[0];
    const encodedId = encodeURIComponent(rawSession || this.Selectedvenue);
    this.apiservice
      .getAttendance(encodedId, this.date, this.endDate)
      .subscribe((data: any) => {
        this.attendanceSummary = data;
        console.log(this.attendanceSummary.childVenues);
        this.entranceGroupTable = this.attendanceSummary.groupedEntries;
        this.latency = this.attendanceSummary.latency;
        this.timedGateEntries = this.parseTimedGateEntries(
          data.timedGateEntries
        );
        this.timedScannerEntries = this.parseTimedScannerEntries(
          data.timedScannerEntries
        );
        this.updateFifteenMinIndices();
        console.log(this.timedGateEntries);
        console.log(this.timedScannerEntries);
        this.gateChartData.labels =
          this.timedGateEntries.length > 0
            ? this.timedGateEntries[0].timestamps
            : [];
        this.scannerChartData.labels =
          this.timedScannerEntries.length > 0
            ? this.timedScannerEntries[0].timestamps
            : [];
        this.selectedGates = [];
        this.selectedScanners = [];
        this.updateChart();
        this.displayData = true;
        this.loading = false;
        this.groupedInside = {};
        console.log(this.attendanceSummary);

        for (const key in this.attendanceSummary.groupedEntries) {
          const entries = this.attendanceSummary.groupedEntries[key].entries;
          const exits = this.attendanceSummary.groupedEntries[key].exits;
          const reentries =
            this.attendanceSummary.groupedEntries[key].reentries;

          this.groupedInside[key] = entries - exits + Number(reentries);
        }

        this.processTicketTypes();
        this.computeScanMetrics();
        this.maybeTriggerFireworks();
      });
    this.getLiveData();
  }

  async getLiveData() {
    // Guard against overlapping connects: a dropped socket triggers a reconnect
    // via onclose, and the await below yields, so without this two callers could
    // each open a socket and leave one orphaned (its frames never processed).
    if (this.connecting) return;
    this.connecting = true;

    // Tear the previous socket down before replacing it. Detaching its handlers
    // first stops its onclose from driving a second, competing reconnect that
    // would trample this.socket and orphan the live connection.
    this.teardownSocket();
    this.manualSocketClose = false;

    let socket: WebSocket;
    try {
      const session = await this.auth.getCurrentSession();
      const token = session?.accessToken;
      const rawSession = this.SelectedSession?.split('_')[0];
      const encodedId = encodeURIComponent(rawSession || this.Selectedvenue);
      const wsEndpoint = environment.wsEndpoint + token + '&venue=' + encodedId;

      socket = new WebSocket(wsEndpoint);
      this.socket = socket;
    } finally {
      this.connecting = false;
    }

    // Bind handlers to the local `socket` so they always reference this exact
    // connection, even if this.socket is later reassigned by a reconnect.
    socket.onopen = () => {
      this.manualSocketClose = false;
    };

    socket.onmessage = (event) => {
      this.handleSocketMessage(event.data);
    };

    socket.onclose = () => {
      console.log('WebSocket connection closed.');
      // Ignore a stale socket's close once it's been replaced.
      if (socket !== this.socket) return;
      if (!this.manualSocketClose) {
        this.liveButton = false;
        this.getLiveData();
        console.log('WebSocket connection re-established.');
      } else {
        console.log('WebSocket is already closed');
      }
    };

    socket.onerror = () => {
      this.stopDataToggle = false;
      this.LiveDate = '';
    };
  }

  /**
   * Detaches the current socket's handlers and closes it. Nulling the handlers
   * first ensures the old socket's onclose can't fire a competing reconnect
   * after we've moved on to a new connection.
   */
  private teardownSocket() {
    if (this.socket) {
      this.socket.onopen = null;
      this.socket.onmessage = null;
      this.socket.onclose = null;
      this.socket.onerror = null;
      this.socket.close();
      this.socket = null;
    }
  }

  private async handleSocketMessage(data: any): Promise<void> {
    try {
      let text: string | null = null;

      if (typeof data === 'string') {
        text = this.maybeUngzipBase64(data);
      } else if (data instanceof Blob) {
        const buf = await data.arrayBuffer();
        text = this.bytesToText(new Uint8Array(buf));
      } else if (data instanceof ArrayBuffer) {
        text = this.bytesToText(new Uint8Array(data));
      } else {
        return;
      }

      if (!text) return;

      const payload = JSON.parse(text);
      this.applySocketPayload(payload);
    } catch (error) {
      console.error('Error handling socket message:', error);
    }
  }

  private maybeUngzipBase64(input: string): string | null {
    const trimmed = input.trim();
    if (!trimmed) return null;
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      return trimmed;
    }
    if (!/^[A-Za-z0-9+/=\s]+$/.test(trimmed)) {
      return trimmed;
    }
    try {
      const binary = atob(trimmed.replace(/\s+/g, ''));
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      return this.bytesToText(bytes);
    } catch {
      return trimmed;
    }
  }

  private bytesToText(bytes: Uint8Array): string {
    if (bytes.length >= 2 && bytes[0] === 0x1f && bytes[1] === 0x8b) {
      return pako.ungzip(bytes, { to: 'string' });
    }
    return new TextDecoder('utf-8').decode(bytes);
  }

  private applySocketPayload(payload: any): void {
    const attendID = payload?.attendID;
    if (!attendID) return;

    const liveDate = String(attendID).substring(String(attendID).lastIndexOf('_') + 1);
    if (this.date != liveDate) {
      this.closeSocket();
      return;
    }

    this.stopDataToggle = true;
    // Frames are complementary slices of one report: the backend strips
    // events/ticketTypes/entrances from the timed frames and the timed series
    // from `main`. Merge rather than replace, or each timed frame would wipe
    // the tables the previous `main` frame populated.
    this.attendanceSummary = { ...(this.attendanceSummary || {}), ...payload };
    if (payload.timedGateEntries !== undefined) {
      this.timedGateEntries = this.parseTimedGateEntries(payload.timedGateEntries);
    }
    if (payload.timedScannerEntries !== undefined) {
      this.timedScannerEntries = this.parseTimedScannerEntries(payload.timedScannerEntries);
    }
    this.updateFifteenMinIndices();
    this.gateChartData.labels =
      this.timedGateEntries.length > 0 ? this.timedGateEntries[0].timestamps : [];
    this.scannerChartData.labels =
      this.timedScannerEntries.length > 0 ? this.timedScannerEntries[0].timestamps : [];
    this.updateChart();

    this.groupedInside = {};
    for (const key in payload.groupedEntries || {}) {
      const entries = Number(payload.groupedEntries[key].entries || 0);
      const exits = Number(payload.groupedEntries[key].exits || 0);
      const reentries = Number(payload.groupedEntries[key].reentries || 0);
      this.groupedInside[key] = entries - exits + reentries;
    }

    this.LiveDate = '(Live Attendance)';
    this.processTicketTypes();
    this.computeScanMetrics();
    this.maybeTriggerFireworks();
  }

  closeSocket() {
    if (this.socket) {
      // Mark intent before tearing down so any in-flight reconnect is suppressed.
      this.manualSocketClose = true;
      this.teardownSocket();
      console.log('WebSocket connection manually closed');
    } else {
      this.manualSocketClose = true;
      console.log('No active WebSocket connection to close.');
    }
  }

  liveData() {
    this.getLiveData();
    this.LiveDate = '(Live Attendance)';
    this.stopDataToggle = true;
    this.liveButton = false;
  }

  stopData() {
    this.closeSocket();
    this.stopDataToggle = false;
    this.LiveDate = '';
    this.liveButton = true;
  }

  getCurrentDate() {
    const zone = this.venueTimezone || 'UTC';
    const now = DateTime.now().setZone(zone);
    this.currentDate = now.toFormat('yyyy-MM-dd');
    this.date = this.currentDate;
  }

  openModal(): void {
    this.isModalOpen = true;
    this.getShareLink();
  }

  openSessionModal(): void {
    this.isSessionModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false;
    this.isSessionModalOpen = false;
    this.shareLink = '';
  }

  getShareLink() {
    this.apiservice.getShareLink(this.Selectedvenue, this.date).subscribe(
      (result: any) => {
        this.shareKey = result.shareKey;
        this.shareLink =
          'https://attend.tmaster.com.au/share?&key=' + this.shareKey;
      },
      (error: any) => {
        console.error('Error fetching share link:', error);
      }
    );
  }

  copyLink() {
    navigator.clipboard.writeText(this.shareLink);
  }

  downloadSummaryCSV() {
    const generateTableData = (header: string[], dataObject: any) => {
      const tableData = [header];
      for (let key of this.venue.objectKeys(dataObject)) {
        tableData.push([
          key,
          dataObject[key].entries,
          dataObject[key].exits,
          dataObject[key].internal,
          dataObject[key].reentries,
          dataObject[key].inVenue || dataObject[key].Inside,
        ]);
      }
      return tableData;
    };

    const summaryTableData = [
      ['Entries', 'Exits', 'Internal', 'Reentries', 'Inside'],
      [
        this.attendanceSummary.entries,
        this.attendanceSummary.exits,
        this.attendanceSummary.internal,
        this.attendanceSummary.reentries,
        this.attendanceSummary.inVenue,
      ],
    ];

    const entranceTableData = generateTableData(
      ['Gate Name', 'Entries', 'Exits', 'Internal', 'Reentries', 'Inside'],
      this.attendanceSummary.entrances
    );

    const eventTableData = generateTableData(
      ['Event Name', 'Entries', 'Exits', 'Internal', 'Reentries', 'Inside'],
      this.attendanceSummary.events
    );

    const ticketTableData = generateTableData(
      [
        'DATABASE | Event | Ticket Type',
        'Entries',
        'Exits',
        'Internal',
        'Reentries',
        'Inside',
      ],
      this.attendanceSummary.ticketTypes
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.aoa_to_sheet(summaryTableData),
      'Attendance Summary'
    );
    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.aoa_to_sheet(entranceTableData),
      'Entrance Summary'
    );
    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.aoa_to_sheet(eventTableData),
      'Event Summary'
    );
    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.aoa_to_sheet(ticketTableData),
      'Ticket Type Summary'
    );

    if (this.attendanceSummary.groupedEntries) {
      const groupedEntranceTableData = generateTableData(
        ['Event Name', 'Entries', 'Exits', 'Internal', 'Reentries', 'Inside'],
        this.attendanceSummary.groupedEntries
      );
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.aoa_to_sheet(groupedEntranceTableData),
        'Grouped Entrance Summary'
      );
    }

    const venueObject = this.venuelist.find(
      (venue) => venue.key === this.Selectedvenue
    );
    this.venueValue =
      venueObject && venueObject.value ? venueObject.value.name : '';

    XLSX.writeFile(workbook, this.venueValue + '_' + this.date + '.xlsx');
  }

  private tableSections: (keyof Pick<
    AttendanceComponent,
    | 'showSummary'
    | 'showGroup'
    | 'showEntrance'
    | 'showEvent'
    | 'showTicket'
    | 'showGraph'
    | 'showTimedEntries'
  >)[] = [
    'showSummary',
    'showGroup',
    'showEntrance',
    'showEvent',
    'showTicket',
    'showGraph',
    'showTimedEntries',
  ];

  toggleTable(section: keyof AttendanceComponent): void {
    this.tableSections.forEach((sec) => {
      this[sec] = sec === section ? !this[sec] : false;
      localStorage.setItem(sec, String(this[sec]));
      localStorage.setItem(
        `buttonClicked${sec.charAt(0).toUpperCase() + sec.slice(1)}`,
        String(this[sec])
      );
    });
  }

  toggleDateRangeCheckBox() {
    if (this.dateRange == true) {
      return true;
    } else {
      return false;
    }
  }

  selectDateRangeChangeHandler(event: any) {
    this.stopDataToggle = false;
    this.LiveDate = '';
    this.displayData = false;
    if (event.target.checked) {
      this.dateRange = true;
      this.closeSocket();
      this.endDate = this.date;
      this.date = '';
    } else {
      this.dateRange = false;
      this.date = this.endDate;
      this.getVenueAttendance();
      this.displayData = false;
      this.endDate = '';
    }
  }

  getASTATFile(event: any) {
    this.loading = true;
    this.apiservice.getASTAT(this.Selectedvenue, this.date).subscribe(
      (result: string) => {
        this.astatreport = result;
        this.downloadAstatCSV();
        this.loading = false;
      },
      (error: any) => {
        console.error('Error fetching ASTAT file:', error);
        this.loading = false;
      }
    );
  }

  downloadAstatCSV() {
    const blob = new Blob([this.astatreport], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    const venueObject = this.venuelist.find(
      (venue) => venue.key === this.Selectedvenue
    );
    this.venueValue =
      venueObject && venueObject.value ? venueObject.value.name : '';

    a.download = this.venueValue + '_' + this.date + '.csv';

    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  deselectAll(value: string) {
    if (value === 'scanners') {
      this.selectedScanners = [];
    } else if (value === 'gates') {
      this.selectedGates = [];
    }
    this.updateChart();
  }

  selectAll(value: string): void {
    if (value === 'scanners') {
      this.selectedScanners = this.timedScannerEntries.map((s) => s.gate);
    } else if (value === 'gates') {
      this.selectedGates = this.timedGateEntries.map((g) => g.gate);
    }
    this.updateChart();
  }

  fireworkIntensity: number = 0;
  fireworkLabel: string = '';
  private readonly fireworkThresholds: number[] = [1000, 5000, 10000, 50000, 75000, 100000];
  private fireworksCrossed = new Set<number>();
  private lastEntriesValue: number = 0;
  private fireworksContextKey: string = '';

  private maybeTriggerFireworks(): void {
    const entries = Number(this.attendanceSummary?.entries || 0);
    if (!isFinite(entries)) {
      this.lastEntriesValue = 0;
      return;
    }

    const contextKey = `${this.Selectedvenue}|${this.SelectedSession}|${this.date}|${this.endDate}`;
    if (contextKey !== this.fireworksContextKey) {
      this.fireworksContextKey = contextKey;
      this.fireworksCrossed.clear();
      for (const t of this.fireworkThresholds) {
        if (entries >= t) this.fireworksCrossed.add(t);
      }
      this.lastEntriesValue = entries;
      return;
    }

    if (entries <= this.lastEntriesValue) {
      this.lastEntriesValue = entries;
      return;
    }

    for (let i = 0; i < this.fireworkThresholds.length; i++) {
      const threshold = this.fireworkThresholds[i];
      if (entries >= threshold && !this.fireworksCrossed.has(threshold)) {
        this.fireworksCrossed.add(threshold);
        this.fireworkLabel = `${threshold.toLocaleString()} entries!`;
        this.fireworkIntensity = 0;
        setTimeout(() => {
          this.fireworkIntensity = i + 1;
        });
      }
    }

    this.lastEntriesValue = entries;
  }

  toggleView(): void {
    this.useModernView = !this.useModernView;
    localStorage.setItem('attendanceUseModernView', String(this.useModernView));
    this.applyDarkModeToBody();
    this.refreshChartOptions();
  }

  setDarkMode(on: boolean): void {
    this.useDarkMode = on;
    localStorage.setItem('attendanceUseDarkMode', String(on));
    this.applyDarkModeToBody();
    this.refreshChartOptions();
  }

  onDarkModeToggle(event: any): void {
    this.setDarkMode(!!event?.target?.checked);
  }

  private applyDarkModeToBody(): void {
    const active = this.useModernView && this.useDarkMode;
    document.body.classList.toggle('attendance-dark', active);
  }

  /** Opens the full-screen big-screen dashboard overlay over the attendance page. */
  openBigScreen(): void {
    this.bigScreenOpen = true;
  }

  closeBigScreen(): void {
    this.bigScreenOpen = false;
  }

  actionMenuOpen: boolean = false;

  toggleActionMenu(): void {
    this.actionMenuOpen = !this.actionMenuOpen;
  }

  closeActionMenu(): void {
    this.actionMenuOpen = false;
  }

  toggleDateRange(): void {
    this.selectDateRangeChangeHandler({ target: { checked: !this.dateRange } });
  }

  // Rebuilds the reject-code columns and sorted-row caches the legacy summary
  // tables depend on. The modern-view scan metrics (rates, entrance and error
  // breakdowns) are derived independently inside <app-modern-summary>.
  computeScanMetrics(): void {
    const summary = this.attendanceSummary || {};

    this.rejectColumnsByTable = {
      entrances: this.collectRejectCodes(summary.entrances),
      events: this.collectRejectCodes(summary.events),
      groupedEntries: this.collectRejectCodes(summary.groupedEntries),
      childVenues: this.collectRejectCodes([{ rejects: summary.rejects }, ...Object.values(summary.childVenues || {})]),
      ticketTypes: this.collectRejectCodes(summary.ticketTypes),
    };

    this.refreshSortedCaches();
  }

  private lastChartTheme: 'light' | 'dark' = 'light';

  processTicketTypes() {
    // ticketTypes is absent until the first `main` frame arrives (timed
    // frames don't carry it), so default to empty rather than crashing.
    this.processedTicketTypes = Object.keys(
      this.attendanceSummary?.ticketTypes || {}
    ).map((key) => {
      const parts = key.split('|');
      return {
        database: parts[0] || '',
        event: parts[1] || '',
        ticketType: parts[2] || '',
        ...this.attendanceSummary.ticketTypes[key],
      };
    });
  }

  getSessions() {
    this.sessions = [];
    this.apiservice
      .getSessions(this.Selectedvenue, this.date)
      .subscribe((data: any) => {
        this.sessions = data.sessions;
      });
  }

  onSessionChange(event: any) {
    const selectedValue = event.target.value;
    this.selectedSessionLabel = event.target.options[event.target.selectedIndex].text;
    if (selectedValue === 'All') {
      this.SelectedSession = '';
      this.closeSocket();
      this.stopDataToggle = false;
      this.getVenueAttendance();
    } else if (selectedValue === 'New Session') {
      this.openSessionModal();
    } else {
      this.selectedSessionTime = this.sessions.find(
        (s) => s.key === selectedValue
      );
      this.closeSocket();
      this.stopDataToggle = false;
      this.SelectedSession = selectedValue;
      this.getVenueAttendance();
    }
  }

  newSession(event: any) {
    this.openSessionModal();
  }

  downloadTimedGateEntries(): void {
    this.venueValue = this.venuelist.find(
      (venue) => venue.key === this.Selectedvenue
    )?.value.name;

    this.exportTimedEntries(
      this.timedGateEntries,
      this.venueValue + '__' + this.date + '_TimedEntriesByGate.xlsx'
    );
  }

  downloadTimedScannerEntries(): void {
    this.venueValue = this.venuelist.find(
      (venue) => venue.key === this.Selectedvenue
    )?.value.name;
    this.exportTimedEntries(
      this.timedScannerEntries,
      this.venueValue + '_' + this.date + '_TimedEntriesByScanner.xlsx'
    );
  }

  private exportTimedEntries(dataset: any[], filename: string) {
    if (!dataset?.length) {
      console.error('No entries to export');
      return;
    }

    const metrics = ['entries', 'exits', 'reentries', 'internal', 'inVenue'];
    const workbook = XLSX.utils.book_new();
    const timestamps = dataset[0].timestamps;

    metrics.forEach((metric) => {
      const sheetData: any[][] = [['Timestamp', ...dataset.map((g) => g.gate)]];

      timestamps.forEach((ts: number, idx: number) => {
        const utcDate = new Date(ts);
        const localDate = this.convertToTimezone(utcDate, this.venueTimezone);
        const excelDate = this.dateToExcel(localDate);

        const row: any[] = [excelDate];
        dataset.forEach((g) => row.push(g[metric][idx] ?? 0));
        sheetData.push(row);
      });

      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      const range = XLSX.utils.decode_range(ws['!ref'] as string);

      for (let R = 1; R <= range.e.r; ++R) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: 0 });
        if (ws[cellRef]) {
          ws[cellRef].t = 'n';
          ws[cellRef].z = 'yyyy-mm-dd hh:mm:ss';
        }
      }

      XLSX.utils.book_append_sheet(
        workbook,
        ws,
        metric.charAt(0).toUpperCase() + metric.slice(1)
      );
    });

    XLSX.writeFile(workbook, filename);
  }

  private dateToExcel(date: Date): number {
    return (
      (date.getTime() - new Date(Date.UTC(1899, 11, 30)).getTime()) /
      (1000 * 60 * 60 * 24)
    );
  }

  private convertToTimezone(date: Date, timeZone: string): Date {
    const parts = new Intl.DateTimeFormat('en-AU', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(date);

    const lookup: any = {};
    parts.forEach((p) => (lookup[p.type] = p.value));

    return new Date(
      Date.UTC(
        Number(lookup.year),
        Number(lookup.month) - 1,
        Number(lookup.day),
        Number(lookup.hour),
        Number(lookup.minute),
        Number(lookup.second)
      )
    );
  }

 toggleDropdown() {
  this.dropdownOpen = !this.dropdownOpen;

  if (this.dropdownOpen) {
    this.filteredGateEntries = [...this.timedGateEntries];
  }
}

  toggleScannerDropdown() {
    this.scannerDropdownOpen = !this.scannerDropdownOpen;

    if (this.scannerDropdownOpen) {
      this.filteredScannerEntries = [...this.timedScannerEntries];
    }
  }

  filterScanners(event: any) {
    const search = event.target.value.toLowerCase();
    this.filteredScannerEntries = this.timedScannerEntries.filter((s) =>
      s.gate.toLowerCase().includes(search)
    );
  }

 filterGates(event: any) {
  const search = (event.target.value || '').toLowerCase();

  this.filteredGateEntries = this.timedGateEntries.filter(g =>
    g.gate.toLowerCase().includes(search)
  );
}


  sendEmail() {
  const now = new Date();
  const currentTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

  const venueObject = this.venuelist.find(
    (venue) => venue.key === this.Selectedvenue
  );
  const venueValue =
    venueObject && venueObject.value ? venueObject.value.name : '';

  this.apiservice.getShareLink(this.Selectedvenue, this.date).subscribe(
    (result: any) => {
      const shareKey = result.shareKey;
      const shareLink = 'https://attend.tmaster.com.au/share?&key=' + shareKey;

      const subject = encodeURIComponent(
        'Attendance Report for ' + venueValue + ': ' + this.date + ' ' + currentTime
      );

      const body = encodeURIComponent(
        "Attendance Summary for " + venueValue + " as at " + currentTime + " on " + this.date + "\n\n" +
        "Entries: " + this.attendanceSummary.entries + "\n" +
        "Exits: " + this.attendanceSummary.exits + "\n" +
        "Internal: " + this.attendanceSummary.internal + "\n" +
        "Reentries: " + this.attendanceSummary.reentries + "\n" +
        "Inside: " + this.attendanceSummary.inVenue + "\n\n" +
        "For more details, please visit the link below:\n" +
        shareLink
      );

      const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
      window.location.href = mailtoLink;
    },
    (error: any) => {
      console.error('Error fetching share link:', error);
    }
  );
}


  async openScheduleModal(): Promise<void> {
    this.isScheduleModalOpen = true;
    this.scheduleEditMode = false;
    this.scheduleError = '';
    this.scheduleSuccess = '';
    this.allSchedules = [];
    this.showCopyDatePicker = false;
    this.copyToDate = '';
    this.selectedScheduleId = null;
    this.scheduleDate = this.date || new Date().toISOString().split('T')[0];

    try {
      const user = await this.auth.getCurrentUser();
      this.currentUserID = user.username;
    } catch {
      this.currentUserID = '';
    }

    this.loadScheduleForDate();
  }

  loadScheduleForDate(): void {
    this.scheduleLoading = true;
    this.scheduleError = '';
    this.scheduleSuccess = '';
    this.allSchedules = [];
    this.scheduleEditMode = false;
    this.editingExistingSchedule = false;
    this.selectedScheduleId = null;

    this.apiservice
      .getScheduleDelivery(this.Selectedvenue, this.scheduleDate)
      .subscribe(
        (result: any) => {
          this.scheduleLoading = false;
          if (result?.schedules?.length) {
            this.allSchedules = result.schedules.map((s: any) => ({
              ...s,
              emailList: s.emails ? Object.values(s.emails as Record<string, string>) : [],
            }));
          }
        },
        (error: any) => {
          this.scheduleLoading = false;
          console.error('Error fetching schedule:', error);
        }
      );
  }

  onScheduleDateChange(): void {
    this.loadScheduleForDate();
  }

  selectSchedule(schedule: any): void {
    this.scheduleEditMode = true;
    this.editingExistingSchedule = true;
    this.selectedScheduleId = schedule.scheduleId != null ? Number(schedule.scheduleId) : null;
    this.scheduleName = schedule.name ?? '';
    // A record written before sendType existed is treated as "interval".
    this.scheduleSendType = schedule.sendType === 'fixed' ? 'fixed' : 'interval';
    this.scheduleFrequency = Number(schedule.frequency) || 5;
    this.scheduleStartTime = schedule.startTime ?? '';
    this.scheduleEndTime = schedule.endTime ?? '';
    this.scheduleSendTime = schedule.sendTime ?? '';
    this.scheduleEmails = schedule.emailList ? [...schedule.emailList] : [];
    this.scheduleEmailInput = '';
    this.scheduleError = '';
    this.scheduleSuccess = '';
    this.showCopyDatePicker = false;
    this.copyToDate = '';
  }

  async startNewSchedule(): Promise<void> {
    this.scheduleEditMode = true;
    this.editingExistingSchedule = false;
    this.selectedScheduleId = null;
    this.scheduleName = '';
    this.scheduleSendType = 'interval';
    this.scheduleFrequency = 5;
    this.scheduleStartTime = '';
    this.scheduleEndTime = '';
    this.scheduleSendTime = '';
    this.scheduleEmailInput = '';
    this.scheduleError = '';
    this.scheduleSuccess = '';
    this.showCopyDatePicker = false;
    this.copyToDate = '';

    try {
      const user = await this.auth.getCurrentUser();
      const email = user.signInDetails?.loginId ?? '';
      this.scheduleEmails = email ? [email] : [];
    } catch {
      this.scheduleEmails = [];
    }
  }

  backToList(): void {
    this.scheduleEditMode = false;
    this.editingExistingSchedule = false;
    this.selectedScheduleId = null;
    this.scheduleError = '';
    this.scheduleSuccess = '';
    this.showCopyDatePicker = false;
    this.copyToDate = '';
  }

  isExistingScheduleSelected(): boolean {
    return this.editingExistingSchedule;
  }

  closeScheduleModal(): void {
    this.isScheduleModalOpen = false;
    this.scheduleEditMode = false;
    this.scheduleError = '';
    this.scheduleSuccess = '';
    this.allSchedules = [];
    this.scheduleEmails = [];
    this.scheduleEmailInput = '';
    this.scheduleName = '';
    this.scheduleSendType = 'interval';
    this.scheduleFrequency = 5;
    this.scheduleStartTime = '';
    this.scheduleEndTime = '';
    this.scheduleSendTime = '';
    this.scheduleDate = '';
    this.showCopyDatePicker = false;
    this.copyToDate = '';
    this.selectedScheduleId = null;
    this.editingExistingSchedule = false;
  }

  addScheduleEmails(): void {
    const lines = this.scheduleEmailInput.split(/[\n,]+/);
    const newEmails: string[] = [];
    for (const line of lines) {
      const trimmed = line.trim();
      if (trimmed && !this.scheduleEmails.includes(trimmed)) {
        newEmails.push(trimmed);
      }
    }
    if (newEmails.length) {
      this.scheduleEmails = [...this.scheduleEmails, ...newEmails];
    }
    this.scheduleEmailInput = '';
  }

  removeScheduleEmail(email: string): void {
    this.scheduleEmails = this.scheduleEmails.filter(e => e !== email);
  }

  /**
   * Validates the current schedule form. Returns an error message to show the
   * user, or null when the form is valid.
   */
  private validateScheduleForm(): string | null {
    if (!this.scheduleEmails.length) {
      return 'Please add at least one recipient email.';
    }
    if (this.scheduleSendType === 'fixed') {
      const match = /^(\d{2}):(\d{2})$/.exec(this.scheduleSendTime);
      if (!match) {
        return 'Please choose a send time for a fixed schedule.';
      }
      // Backend requires the send time to fall on a 5-minute boundary, matching
      // the scheduler's 5-minute CloudWatch cron ticks.
      if (Number(match[2]) % 5 !== 0) {
        return 'Send time must be on a 5-minute boundary (e.g. 11:00, 11:05).';
      }
    }
    return null;
  }

  /**
   * Builds the POST body for the current schedule form for the given date.
   * Only the fields relevant to the selected send type are included, mirroring
   * what the backend stores.
   */
  private buildScheduleBody(date: string): {
    venue: string;
    date: string;
    emails: string[];
    name?: string;
    sendType: 'interval' | 'fixed';
    frequency?: number;
    startTime?: string;
    endTime?: string;
    sendTime?: string;
    scheduleId?: number;
  } {
    const body = {
      venue: this.Selectedvenue,
      date,
      emails: this.scheduleEmails,
      sendType: this.scheduleSendType,
    } as {
      venue: string;
      date: string;
      emails: string[];
      name?: string;
      sendType: 'interval' | 'fixed';
      frequency?: number;
      startTime?: string;
      endTime?: string;
      sendTime?: string;
    };

    const name = this.scheduleName.trim();
    if (name) { body.name = name; }

    if (this.scheduleSendType === 'fixed') {
      body.sendTime = this.scheduleSendTime;
    } else {
      body.frequency = Number(this.scheduleFrequency);
      if (this.scheduleStartTime) { body.startTime = this.scheduleStartTime; }
      if (this.scheduleEndTime) { body.endTime = this.scheduleEndTime; }
    }

    return body;
  }

  saveSchedule(): void {
    this.scheduleError = '';
    this.scheduleSuccess = '';

    const validationError = this.validateScheduleForm();
    if (validationError) {
      this.scheduleError = validationError;
      return;
    }

    this.scheduleLoading = true;

    const body = this.buildScheduleBody(this.scheduleDate);
    if (this.selectedScheduleId != null) { body.scheduleId = this.selectedScheduleId; }

    this.apiservice.postScheduleDelivery(body).subscribe(
      () => {
        this.scheduleLoading = false;
        this.scheduleSuccess = 'Schedule saved successfully.';
        this.loadScheduleForDate();
      },
      (error: any) => {
        this.scheduleLoading = false;
        this.scheduleError = 'Failed to save schedule. Please try again.';
        console.error('Error saving schedule:', error);
      }
    );
  }

  deleteSchedule(scheduleId?: number): void {
    const targetId = scheduleId ?? this.selectedScheduleId;
    this.scheduleError = '';
    this.scheduleSuccess = '';
    this.scheduleLoading = true;

    this.apiservice
      .deleteScheduleDelivery(this.Selectedvenue, this.scheduleDate, { scheduleId: targetId ?? undefined })
      .subscribe(
        () => {
          this.scheduleLoading = false;
          this.scheduleSuccess = 'Schedule deleted.';
          if (scheduleId != null && this.scheduleEditMode && this.selectedScheduleId === scheduleId) {
            this.scheduleEditMode = false;
          }
          this.loadScheduleForDate();
        },
        (error: any) => {
          this.scheduleLoading = false;
          this.scheduleError = 'Failed to delete schedule. Please try again.';
          console.error('Error deleting schedule:', error);
        }
      );
  }

  toggleCopyDatePicker(): void {
    this.showCopyDatePicker = !this.showCopyDatePicker;
    this.copyToDate = '';
  }

  copyScheduleToDate(): void {
    if (!this.copyToDate) {
      this.scheduleError = 'Please select a date to copy to.';
      return;
    }

    this.scheduleError = '';
    this.scheduleSuccess = '';

    const validationError = this.validateScheduleForm();
    if (validationError) {
      this.scheduleError = validationError;
      return;
    }

    this.scheduleLoading = true;

    // Copy creates a new schedule on the target date, so no scheduleId is sent.
    const body = this.buildScheduleBody(this.copyToDate);

    this.apiservice.postScheduleDelivery(body).subscribe(
      () => {
        this.scheduleLoading = false;
        this.scheduleSuccess = 'Schedule copied to ' + this.copyToDate + '.';
        this.showCopyDatePicker = false;
        this.copyToDate = '';
      },
      (error: any) => {
        this.scheduleLoading = false;
        this.scheduleError = 'Failed to copy schedule. Please try again.';
        console.error('Error copying schedule:', error);
      }
    );
  }

  openManageSessionsModal(): void {
    this.isManageSessionsModalOpen = true;
    this.manageSessionsError = '';
    this.manageSessionsSuccess = '';
    this.manageSessionsNewName = '';
    this.manageSessionsNewStart = '';
    this.manageSessionsNewEnd = '';
    this.manageSessionsDate = this.date || new Date().toISOString().split('T')[0];
    this.loadManageSessions();
  }

  closeManageSessionsModal(): void {
    this.isManageSessionsModalOpen = false;
    this.manageSessionsList = [];
    this.manageSessionsError = '';
    this.manageSessionsSuccess = '';
  }

  onManageSessionsDateChange(): void {
    this.loadManageSessions();
  }

  loadManageSessions(): void {
    this.manageSessionsLoading = true;
    this.manageSessionsError = '';
    this.manageSessionsSuccess = '';
    this.manageSessionsList = [];

    this.apiservice
      .getSessions(this.Selectedvenue, this.manageSessionsDate)
      .subscribe(
        (data: any) => {
          this.manageSessionsLoading = false;
          const sessions: any[] = Array.isArray(data?.sessions) ? data.sessions : [];
          this.manageSessionsList = sessions.map((s) => ({
            key: s.key,
            name: s.name || this.extractSessionSuffix(s.key),
            startTime: this.epochToTimeInput(s.startEpoch),
            endTime: this.epochToTimeInput(s.endEpoch),
          }));
        },
        (error: any) => {
          this.manageSessionsLoading = false;
          console.error('Error fetching sessions:', error);
          this.manageSessionsError = 'Failed to load sessions.';
        }
      );
  }

  addManageSession(): void {
    this.manageSessionsError = '';
    this.manageSessionsSuccess = '';

    const name = this.manageSessionsNewName.trim();
    if (!name) {
      this.manageSessionsError = 'Session name is required.';
      return;
    }
    if (!this.manageSessionsNewStart || !this.manageSessionsNewEnd) {
      this.manageSessionsError = 'Start and end times are required.';
      return;
    }
    if (this.manageSessionsNewEnd <= this.manageSessionsNewStart) {
      this.manageSessionsError = 'End time must be after start time.';
      return;
    }

    const suffix = this.nextSessionSuffix();
    const key = `${this.Selectedvenue}#${suffix}_${this.manageSessionsDate}`;

    this.manageSessionsList = [
      ...this.manageSessionsList,
      {
        key,
        name,
        startTime: this.manageSessionsNewStart,
        endTime: this.manageSessionsNewEnd,
      },
    ];

    this.manageSessionsNewName = '';
    this.manageSessionsNewStart = '';
    this.manageSessionsNewEnd = '';
  }

  removeManageSession(key: string): void {
    this.manageSessionsList = this.manageSessionsList.filter((s) => s.key !== key);
  }

  saveManageSessions(): void {
    this.manageSessionsError = '';
    this.manageSessionsSuccess = '';

    for (const s of this.manageSessionsList) {
      if (!s.name?.trim() || !s.startTime || !s.endTime) {
        this.manageSessionsError = 'All sessions must have a name, start, and end time.';
        return;
      }
      if (s.endTime <= s.startTime) {
        this.manageSessionsError = `Session '${s.name}' has an end time before its start time.`;
        return;
      }
    }

    this.manageSessionsSaving = true;

    const body = {
      key: `session_${this.Selectedvenue}_${this.manageSessionsDate}`,
      sessions: this.manageSessionsList.map((s) => ({
        key: s.key,
        name: s.name.trim(),
        startEpoch: this.timeInputToEpoch(s.startTime, this.manageSessionsDate),
        endEpoch: this.timeInputToEpoch(s.endTime, this.manageSessionsDate),
      })),
    };

    this.apiservice.postSessions(body).subscribe(
      () => {
        this.manageSessionsSaving = false;
        this.manageSessionsSuccess = 'Sessions saved.';
        if (this.manageSessionsDate === this.date) {
          this.getSessions();
        }
      },
      (error: any) => {
        this.manageSessionsSaving = false;
        const serverMessage = typeof error?.error === 'string' ? error.error : '';
        this.manageSessionsError = serverMessage || 'Failed to save sessions. Please try again.';
        console.error('Error saving sessions:', error);
      }
    );
  }

  private extractSessionSuffix(key: string): string {
    const hashIdx = key.indexOf('#');
    if (hashIdx === -1) { return key; }
    const rest = key.substring(hashIdx + 1);
    const underscoreIdx = rest.lastIndexOf('_');
    return underscoreIdx === -1 ? rest : rest.substring(0, underscoreIdx);
  }

  private nextSessionSuffix(): string {
    const usedNumbers = new Set<number>();
    for (const s of this.manageSessionsList) {
      const suffix = this.extractSessionSuffix(s.key);
      const match = /^S(\d+)$/i.exec(suffix);
      if (match) { usedNumbers.add(Number(match[1])); }
    }
    let n = 1;
    while (usedNumbers.has(n)) { n++; }
    return `S${n}`;
  }

  private epochToTimeInput(epoch: number): string {
    if (!epoch) { return ''; }
    const zone = this.venueTimezone || 'UTC';
    return DateTime.fromSeconds(Number(epoch), { zone }).toFormat('HH:mm');
  }

  private timeInputToEpoch(timeValue: string, dateValue: string): number {
    const zone = this.venueTimezone || 'UTC';
    const dt = DateTime.fromFormat(`${dateValue} ${timeValue}`, 'yyyy-MM-dd HH:mm', { zone });
    return Math.floor(dt.toSeconds());
  }

  ngOnInit(): void {
    this.permissions.checkPermissions();
    const savedView = localStorage.getItem('attendanceUseModernView');
    if (savedView !== null) {
      this.useModernView = savedView === 'true';
    }
    const savedDark = localStorage.getItem('attendanceUseDarkMode');
    if (savedDark !== null) {
      this.useDarkMode = savedDark === 'true';
    }
    this.applyDarkModeToBody();
    this.refreshChartOptions();
    window.addEventListener('attendance-modern-view-changed', this.modernViewHandler);
    (window as any).fireworks = (tier: number = 3, label?: string) => {
      this.fireworkLabel = label ?? `${tier * 1000} entries!`;
      this.fireworkIntensity = 0;
      setTimeout(() => {
        this.fireworkIntensity = Math.max(1, Math.min(6, Math.round(tier)));
      });
    };
    this.getVenueList();
    this.filteredScannerEntries = this.timedScannerEntries;
    this.filteredGateEntries = this.timedGateEntries;
  }

  ngOnDestroy(): void {
    window.removeEventListener('attendance-modern-view-changed', this.modernViewHandler);
    document.body.classList.remove('attendance-dark');
    delete (window as any).fireworks;
    this.stopActiveScanPolling();
    // Close the live socket so its reconnect loop doesn't outlive the component.
    this.closeSocket();
  }
}
